/* Giftaty v6 · tiny global helpers (no libraries). Loaded with defer. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll reveal fallback (browsers without CSS animation-timeline)
  var cssTimeline = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');
  var items = document.querySelectorAll('.gt-reveal');
  if (items.length) {
    if (reduce || cssTimeline || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -10% 0px' });
      items.forEach(function (el) { io.observe(el); });
    }
  }

  // WhatsApp FAB: show the label pill for 4s on the first visit of the session
  var wa = document.querySelector('.gt-wa--intro');
  if (wa && !reduce) {
    var seen = false;
    try { seen = sessionStorage.getItem('gt-wa-intro') === '1'; sessionStorage.setItem('gt-wa-intro', '1'); } catch (e) {}
    if (!seen) {
      setTimeout(function () { wa.classList.add('is-intro'); }, 1200);
      setTimeout(function () { wa.classList.remove('is-intro'); }, 5200);
    }
  }

  // Live character counters: <div data-gt-counter> with a textarea/input[maxlength] and .gt-field__count
  document.querySelectorAll('[data-gt-counter]').forEach(function (box) {
    var input = box.querySelector('textarea, input');
    var out = box.querySelector('.gt-field__count');
    if (!input || !out) return;
    var max = input.getAttribute('maxlength');
    var upd = function () { out.textContent = input.value.length + (max ? ' / ' + max : ''); };
    input.addEventListener('input', upd);
    upd();
  });

  // Review form: reopen after a submission so the thank-you / error message is visible
  if (/contact_posted|form_type=contact|contact%5B/.test(location.search + location.hash) || /GtReviewForm/.test(location.hash)) {
    var d = document.querySelector('[data-gt-review-write]');
    if (d) { d.open = true; }
  }
})();
